import type { ReactElement } from 'react';
import { Card, Stack, Text, Textarea, TextInput } from '@mantine/core';
import type { CategoryNoun } from './ClassificationOptions';

interface ClassificationDefinitionCardProps {
    name: string;
    description: string;
    noun: CategoryNoun;
    onNameChange: (value: string) => void;
    onDescriptionChange: (value: string) => void;
}

export default function ClassificationDefinitionCard({
    name,
    description,
    noun,
    onNameChange,
    onDescriptionChange,
}: ClassificationDefinitionCardProps): ReactElement {
    return (
        <Card withBorder radius="md" padding="lg">
            <Stack gap="xs" mb="md">
                <Text fw={800} size="sm">
                    1 · {noun.singular} Definition
                </Text>
                <Text size="xs" c="dimmed">
                    What behavior or signal should this {noun.singular.toLowerCase()} capture?
                </Text>
            </Stack>

            <Stack gap="md">
                <TextInput
                    label={`${noun.singular} name`}
                    placeholder="e.g. Premium-tier overuse on low-difficulty tasks"
                    value={name}
                    onChange={(e) => onNameChange(e.currentTarget.value)}
                />
                <Textarea
                    label="Plain-language description"
                    placeholder="Describe the behavior to flag in users' sessions…"
                    autosize
                    minRows={3}
                    value={description}
                    onChange={(e) => onDescriptionChange(e.currentTarget.value)}
                />
            </Stack>
        </Card>
    );
}
